import { render } from "./MCampaign.vue?vue&type=template&id=7abd147c&ts=true"
import script from "./MCampaign.vue?vue&type=script&lang=ts"
export * from "./MCampaign.vue?vue&type=script&lang=ts"

import "./MCampaign.vue?vue&type=style&index=0&id=7abd147c&lang=scss"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__